import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import {
  cleanupPreviewModuleCaches,
  isPreviewOrIframeContext,
  scheduleModuleImportRecoveryStateReset,
} from "./lib/moduleLoadRecovery";
import "./index.css";

/**
 * In preview/iframe contexts (Lovable editor), unregister any stale
 * Workbox service workers that may serve outdated cached chunks.
 * The push SW (sw-push.js) is NOT affected — it only handles push events.
 */
async function guardServiceWorkers() {
  if (!isPreviewOrIframeContext()) return;
  if (!("serviceWorker" in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const reg of registrations) {
      // Keep the push SW alive — only kill Workbox/PWA SWs
      const swUrl = reg.active?.scriptURL ?? reg.installing?.scriptURL ?? "";
      if (swUrl.includes("sw-push")) continue;
      await reg.unregister();
    }
  } catch {
    // Ignore — best-effort cleanup
  }
}

async function bootstrap() {
  try {
    await Promise.all([
      cleanupPreviewModuleCaches(),
      guardServiceWorkers(),
    ]);
  } finally {
    createRoot(document.getElementById("root")!).render(<App />);
    scheduleModuleImportRecoveryStateReset();
  }
}

void bootstrap();
